import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
class DemoList extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			customers: [],
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			activePage: 1,
			item_count: "",
			from_date: "",
			to_date: "",
			search: "",
			studio_id: "",
			user_id: "",
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			isLoadMore: 1,
			Loading: 1,
			show: true,
			allmuvisix: [],
			muvisixproductkey: "3D28C83C85544F0D9517DD2E7C7EEDAA",
			customerByproductName: [],
			user_data: "",
			offset: 0,
			muviFiveCount: null,
			muvi6all: [],
			showMenu: false,
			isMuviOne: false,
			store_permission: localStorage.getItem("store_permission"),
			is_general_user: localStorage.getItem("is_general_user"),
		};
		this.onChange = this.onChange.bind(this);
		this.getCustomers = this.getCustomers.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.formdateChange = this.formdateChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}
	goToCustomerStore(email, password, studio_id, studio_name) {
		if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
			var win = window.open(
				this.state.studioUrl +
					"/login/storeLogin" +
					"?email=" +
					email +
					"&password=" +
					password +
					"&studio_id=" +
					studio_id,
				"_blank"
			);
			win.focus();
		}
	}
	formdateChange(event) {
		this.setState({ from_date: event.target.value }, function () {
			this.getCustomers();
		});
	}
	todateChange(event) {
		this.setState({ to_date: event.target.value }, function () {
			this.getCustomers();
		});
	}
	keywordChange(event) {
		var obj = this;
		this.setState({
			search: event.target.value,
			activePage: 1,
			customers: [],
			Loading: 1,
		});
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		if (obj.state.muvisixproductkey != "") {
			this.timer = window.setTimeout(() => {
				obj.muvisixCustomerSearchHandler();
			}, 500);
		} else {
			this.timer = window.setTimeout(function () {
				//Execute the function code here...
				obj.getCustomers();
			}, 500);
		}
	}

	muvisixCustomerSearchHandler = () => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${this.state.muvisixproductkey}", type: \"Demo\", page: 0, size: 20, search : \"${this.state.search}") {page_info{total_count}, user_details {username, name, email, mobile, created_date, company_name, country_name, ip_address,    address, product_name, user_uuid, user_status, profile_image_url, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, domain_name, custom_cancellation_reason, created_date, free_trial_expiry_date, package_name, package_summary, package_period, account_status, source, store_key, number_of_login}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((data) => {
						this.setState({
							customers: data.data.getCustomerList.user_details,
							item_count: data.data.getCustomerList.page_info.total_count,
							Loading: 0,
						});
					});
			}
		);
	};
	customer_details(studio_id, studio_name, user_id) {
		document.getElementById("new_password").value = "";
		fetch(
			this.state.apiUrl +
				"/AdminRest/customerdetails/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					user_id: findresponse.user_id,
				});
			});
	}
	movefromDemo(studio_id, studio_name, user_id) {
		if (window.confirm("Are you sure you want to remove '" + studio_name + "' account from demo studio?")) {
			fetch(
				this.state.apiUrl +
					"/adminRest/movefromDemo/id/" +
					studio_id +
					"/userAuthKey/" +
					this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message: findresponse.msg, show: false });
					} else {
						this.setState({ message: findresponse.msg });
					}
					this.getCustomers();
					this.setState({});
				});
		}
	}

	CancelAccount(studio_id, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/CancelAccount/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message1: findresponse.msg }, function () {
						window.location.href = "/demoStores";
					});
				} else {
					this.setState({ message1: findresponse.msg });
				}
			});
	}

	Savepassword(studio_id, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/Savepassword/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () {
						window.location.href = "/demoStores";
					});
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}
	handlePageChange(pageNumber = 1) {
		if (this.state.muvisixproductkey != "") {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${
							this.state.muvisixproductkey
						}", type: \"Demo\", page: ${pageNumber - 1}, size: 20, search : \"${
							this.state.search
						}") {page_info{total_count}, user_details {username, name, email, mobile, created_date, store_key, company_name, country_name, ip_address, address, product_name,    user_uuid, user_status, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, domain_name, custom_cancellation_reason, created_date, free_trial_expiry_date, package_name, package_summary,  package_period,account_status, source, domain_name,number_of_login}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
							loading: 0,
							activePage: pageNumber,
							setPage: "yes",
						});
					});
			}
		} else {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch(
					this.state.apiUrl +
						"/adminRest/GetdemoStores/page/" +
						pageNumber +
						"/userAuthKey/" +
						this.state.userAuthKey +
						"/userId/" +
						this.state.userId,
					{
						method: "POST",
						dataType: "json",
						body: JSON.stringify(this.state),
					}
				)
					.then((Response) => Response.json())
					.then((findresponse) => {
						findresponse = this.rawjsonparse(findresponse, 1);
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.customers,
							offset: findresponse.offset,
							off_count: findresponse.off_count,
							setPage: "yes",
						});
					});
			}
		}
	}

	getCustomers(page = 1) {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetdemoStores/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					item_count: findresponse.item_count,
					muviFiveCount: findresponse.item_count,
					store_permission: findresponse.store_permission,
					is_general_user: findresponse.is_general_user,
					Loading: 0,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
					muvisixproductkey: "",
				});
			});
	}

	getMuvisixCustomer = (event, cond = 0) => {
		if (cond == 1) {
			var prod_key = event.target;
		} else {
			const { value } = event.target;
			var prod_key = value;
		}
		this.setState({ isMuviOne: false });
		if (prod_key !== "") {
			if (prod_key == "3D28C83C85544F0D9517DD2E7C7EEDAA") {
				this.setState({ isMuviOne: true });
			}
			this.setState(
				{
					Loading: 1,
					search: "",
				},
				() => {
					this.getCustomersforSearch();
					fetch("https://apigateway.muvi.com/customer-list", {
						method: "POST",
						dataType: "json",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							query: `{getCustomerList( product_key: "${prod_key}", type: \"Demo\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, company_name,country_name, store_key, ip_address, address, product_name, user_uuid, user_status, deleted_date, app_token,created_date, onhold_period, canceled_date,cancellation_reason, canceled_by,package_name,deleted_reason, deleted_by,plan_name, source, domain_name, number_of_login}}}`,
						}),
					})
						.then((Response) => Response.json())
						.then((findresponse) => {
							this.setState({
								Loading: 0,
								customers: findresponse.data.getCustomerList.user_details,
								item_count: findresponse.data.getCustomerList.page_info.total_count,
								activePage: 1,
								setPage: "yes",
							});
						});

					this.setState({
						muvisixproductkey: prod_key,
					});
				}
			);
		} else {
			this.setState(
				{
					activePage: 1,
					customerByproductName: [],
					search: "",
				},
				() => {
					this.getCustomers(1);
				}
			);
		}
	};

	getCustomersforSearch = (page = 1) => {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetdemoStores/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					muviFiveCount: findresponse.item_count,
				});
			});
	};

	userDataEncrypt = async (productkey, userid, uname) => {
		const REDIRECT_URL = `https://account.muvi.com`;
		if (window.confirm(`Are you sure to login this store ${uname}`)) {
			const loginDetails = {
				product_key: `${productkey}`,
				user_uuid: `${userid}`,
				muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
			};

			const response = await fetch(
				this.state.apiUrl + "/adminRest/encData/userAuthKey/" + this.state.userAuthKey,
				{
					method: "POST",
					// headers: {
					//     'content-type': 'application/json'
					// },
					body: JSON.stringify(loginDetails),
				}
			);

			const user_data = await response.json();

			this.setState(
				{
					user_data,
					showMenu: false,
					loadMore: 0,
				},
				async () => {
					try {
						const loginRespnse = await fetch(`${this.state.apiUrl}/AdvancedRest/getintraLogin`, {
							method: "POST",
							// headers: {
							//     "content-type": 'application/json'
							// },
							body: JSON.stringify(this.state.user_data),
						});

						const loginRes = await loginRespnse.json();

						const responseLogin = await JSON.parse(loginRes);
						const { data, response, status } = responseLogin;
						if (status === "SUCCESS") {
							window.open(
								`${REDIRECT_URL}/autologin?continue=${data.product_cms_full_url}&token=${response.refresh_token}`,
								"_blank"
							);
							//                          window.open(`${data.urlEndPoint}`, '_blank');
						}
					} catch (error) {
						console.log(error);
					}
				}
			);
		}
	};

	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}

	getCustomersMenu(
		studio_id,
		studio_name,
		user_id,
		email,
		encrypted_password,
		name,
		productkey = null,
		apptoken = null,
		leadToDemo = null,
		useruid = null,
		uname = null,
		storeKey
	) {
		if (this.state.store_permission == 1) {
			const tattleProductKey = "15814865095e4391ada3222422565574";
			return this.state.showMenu ? (
				<ul class="onclick-menu-content">
					{this.state.muvisixproductkey !== "" ? (
						<li onClick={() => this.userDataEncrypt(productkey, useruid, uname)}>
							<a>Log-In to Account</a>
						</li>
					) : (
						<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
							<a>Log-In to Account</a>
						</li>
					)}
					{this.state.muvisixproductkey == "" ? (
						<li
							onClick={() => this.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#changePassword"
						>
							<a>Change Password</a>
						</li>
					) : (
						""
					)}
					{this.state.muvisixproductkey !== "" && this.state.muvisixproductkey !== tattleProductKey ? (
						<li
							onClick={() =>
								this.demoMovetoLead(productkey, apptoken, leadToDemo, useruid, uname, name, storeKey)
							}
						>
							<a>Remove from Demo</a>
						</li>
					) : this.state.muvisixproductkey == "" ? (
						<li onClick={() => this.movefromDemo(studio_id, studio_name, user_id)}>
							<a>Remove from Demo</a>
						</li>
					) : (
						""
					)}
					{this.state.muvisixproductkey == "" ? (
						<li
							onClick={() => this.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#cancelAccount"
						>
							<a>Cancel Account</a>
						</li>
					) : (
						""
					)}
				</ul>
			) : null;
		} else {
			return (
				<ul class="onclick-menu-content">
					{this.state.is_general_user != 1 ? (
						this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)
					) : (
						""
					)}
				</ul>
			);
		}
	}

	demoMovetoLead = async (productKey, appToken, moveToDemo, userId, username, name, storeKey) => {
		if (window.confirm("Are you sure you want to move '" + name + "' account to demo studio?")) {
			fetch("https://apigateway.muvi.com/accounts/manage-demo-account", {
				method: "POST",
				headers: {
					"content-type": "application/json",
				},
				body: JSON.stringify({
					product_key: productKey,
					app_token: appToken,
					is_demo: moveToDemo,
					user_uuid: userId,
					store_key: storeKey ? storeKey : "",
				}),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.fetchProductByKey(productKey);
				});
		}
	};

	fetchProductByKey = (key) => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${key}", type: \"Demo\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, mobile, company_name,country_name, store_key, ip_address, address, product_name, user_uuid, user_status, profile_image_url, deleted_date, app_token,created_date,  canceled_date, canceled_by,  package_name,plan_name, source, domain_name, number_of_login}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						this.setState({
							Loading: 0,
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
						});
					});

				this.setState({
					muvisixproductkey: key,
				});
			}
		);
	};

	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
				"/adminRest/GetdemoStores/page/" +
				pageNumber +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.customers.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					//isLoadMore:1,
					customers: this.state.customers.concat(findresponse.customers),
					//item_count: findresponse.item_count,
				});
			});
	}

	menuHideShow = () => {
		this.setState({
			showMenu: !false,
		});
	};

	export() {
		var win = window.open(
			this.state.apiUrl +
				"/AdminRest/ExportUsers/userAuthKey/" +
				this.state.userAuthKey +
				"/user_type/demo/search/" +
				this.state.search,
			"_self"
		);
		win.focus();
	}
	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}

	getMuviClassicCount(type = "") {
		const customer_type = { type: type };
		fetch("https://cms.muvi.com/intranet/getMuvi5TotalCounts", {
			method: "POST",
			body: JSON.stringify(customer_type),
		})
			.then((Response) => Response.json())
			.then((data) => {
				this.setState({
					muviFiveCount: data.total_count,
				});
			});
	}

	componentDidMount = async () => {
		//        this.getCustomers(1, 1);
		this.getMuviClassicCount(5);
		var muvi_one_prod_key = { target: "3D28C83C85544F0D9517DD2E7C7EEDAA" };
		const muvi_one_product_key = Object.assign({}, muvi_one_prod_key);
		this.getMuvisixCustomer(muvi_one_product_key, 1);

		document.title = "Intranet | Demo";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}

		// fetch(this.state.apiUrl +'/adminRest/getAllMuviSixProduct/userAuthKey/' + this.state.userAuthKey,{

		//         method: 'GET',
		//         }).then( Response => Response.json())
		//             .then( (data) =>{

		//             this.setState({

		//                 allmuvisix: data
		//             })
		//         })
		if (this.props.muvisixproductkey !== "") {
			fetch("https://apigateway.muvi.com/accounts/statistics", {
				method: "POST",
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.setState({
						allmuvisix: data.data,
					});
				});

			const response = await fetch("https://apigateway.muvi.com/demo-accounts-statistics", {
				method: "post",
			});
			const res = await response.json();
			this.setState({
				muvi6all: res.data,
			});
		}
	};

	muviSixpagination = () => {
		if (20 * (this.state.activePage - 1 + 1) > this.state.item_count) {
			return (
				20 * (this.state.activePage - 1) + 1 + " - " + this.state.item_count + " of " + this.state.item_count
			);
		} else {
			return (
				20 * (this.state.activePage - 1) +
				1 +
				" - " +
				20 * (this.state.activePage - 1 + 1) +
				" of " +
				this.state.item_count
			);
		}
	};

	getDemoList() {
		let hideSearchforMuvisix = "";

		hideSearchforMuvisix = (
			<div class="searchTicket mob_customer">
				<input
					type="text"
					value={this.state.search}
					class="form-control"
					name="customer"
					id="customer"
					placeholder="Search company, name or email"
					onChange={this.keywordChange}
				/>
				<button type="submit">
					<i class="fa fa-search"></i>
				</button>
			</div>
		);

		let selectDrop = "";
		if (this.state.muvi6all !== "") {
			selectDrop = (
				<select className="form-control" value={this.muvisixproductkey} onChange={this.getMuvisixCustomer}>
					{this.state.muvi6all.map((item, index) => {
						const { product_name, product_key, demo } = item;
						return item.product_key != "49F37046FCD84520895FC18A4F5BFC8B" ? (
							item.product_key == "3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
								<option value={product_key} key={index} selected>
									{product_name}({demo})
								</option>
							) : (
								<option value={product_key} key={index}>
									{product_name}({demo})
								</option>
							)
						) : (
							<option value="">Muvi One (Classic) ({this.state.muviFiveCount})</option>
						);
					})}
				</select>
			);
		}

		return (
			<section class="customer">
				<div id="exTab1" class="container">
					<CustomerTabMenu brecum_page="demolist" />

					<div class="tab-content clearfix">
						<div class="tab-pane active" id="Demo">
							<div class="row">
								<div class="col-md-5">
									<div class="row">
										<div class="col-md-6">{selectDrop}</div>
									</div>
								</div>

								<div class="col-md-1"></div>

								<div class="col-md-6">{hideSearchforMuvisix}</div>
							</div>

							<div class="tickets hidden-sm">
								<ul class="tickets_head">
									<li class={this.state.muvisixproductkey == "" ? "intra_col_15" : "intra_col_10"}>
										Company
									</li>
									<li class={this.state.muvisixproductkey == "" ? "intra_col_12" : "intra_col_10"}>
										Name
									</li>
									<li class={this.state.muvisixproductkey !== "" ? "intra_col_12" : "intra_col_12"}>
										Email
									</li>
									{this.state.muvisixproductkey === "" || this.state.isMuviOne ? (
										<li
											class={this.state.muvisixproductkey == "" ? "intra_col_10" : "intra_col_10"}
										>
											Website
										</li>
									) : (
										""
									)}
									<li class={this.state.muvisixproductkey != "" ? "intra_col_10" : "intra_col_10"}>
										Country
									</li>
									<li class="intra_col_10">Logins</li>
									<li class={this.state.muvisixproductkey == "" ? "intra_col_15" : "intra_col_15"}>
										Joined On
									</li>
									<li class={this.state.muvisixproductkey == "" ? "intra_col_15" : "intra_col_10"}>
										Source
									</li>
									<li class="intra_col_5"></li>
								</ul>
								{this.state.Loading ? (
									<div>
										<div class="loader-new"></div>
									</div>
								) : (
									this.state.customers.map((data, key) => (
										<ul class="tickets_number">
											<li
												class={
													this.state.muvisixproductkey == ""
														? "intra_col_15 text-inded"
														: "intra_col_10 text-inded"
												}
											>
												{" "}
												{this.state.muvisixproductkey == "" ? (
													<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
														{" "}
														{data.company_name
															? data.company_name
															: data.name
															? data.name
															: "NA"}
													</Link>
												) : (
													<Link key={key} to={`/test/detail/${data.app_token}`} name={"max"}>
														{" "}
														{data.company_name
															? data.company_name
															: data.name
															? data.name
															: "NA"}
													</Link>
												)}
											</li>
											<li
												class={
													this.state.muvisixproductkey == ""
														? "intra_col_12 text-inded"
														: "intra_col_10 text-inded"
												}
											>
												{data.first_name ? data.first_name : data.name ? data.name : "NA"}
											</li>
											<li
												class={
													this.state.muvisixproductkey == "" ? "intra_col_12" : "intra_col_12"
												}
											>
												{data.email ? data.email : "NA"}
											</li>
											{this.state.muvisixproductkey == "" || this.state.isMuviOne ? (
												<li
													class={
														this.state.muvisixproductkey == ""
															? "intra_col_10 text-inded"
															: "intra_col_10 text-inded"
													}
												>
													<a
														href={`http://${data.domain ? data.domain : data.domain_name}`}
														target="_blank"
													>
														{data.domain ? data.domain : data.domain_name}
													</a>
												</li>
											) : (
												""
											)}
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_10" : "intra_col_10"
												}
											>
												{data.country
													? data.country
													: data.country_name
													? data.country_name
													: "NA"}
											</li>
											<li class="intra_col_10">
												{data.logins
													? data.logins
													: data.number_of_login
													? data.number_of_login
													: "NA"}
											</li>
											<li
												class={
													this.state.muvisixproductkey == "" ? "intra_col_15" : "intra_col_15"
												}
											>
												{data.created_at_change
													? new Date(data.created_at_change).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })
													: new Date(data.created_date).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })}
											</li>
											<li
												class={
													this.state.muvisixproductkey != ""
														? "intra_col_15 text-inded"
														: "intra_col_10 text-inded"
												}
											>
												{data.source ? this.getSourceLink(data.source) : "NA"}
											</li>
											{/* <li class="intra_col_5 customer_details" onClick={ () => this.setState({ menusOpen: !false})}>
                                                        <div tabindex="0" class="onclick-menu c-details pull-right">
                                                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                            { this.state.menusOpen ? this.getCustomersMenu(data.studio_id, data.first_name, data.user_id, 
                                                            data.email, data.encrypted_password, data.name, 
                                                            this.state.muvisixproductkey,data.app_token, true, data.user_uuid, data.username) : ''}
                                                        </div>
                                                    </li>  */}
											<li
												onClick={this.menuHideShow}
												style={{ position: "relative" }}
												className="intra_col_5"
											>
												{this.state.is_general_user != 1 ? (
													<div tabindex="0" class="onclick-menu c-details pull-right">
														<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
														{this.getCustomersMenu(
															data.studio_id,
															data.first_name,
															data.user_id,
															data.email,
															data.encrypted_password,
															data.name,
															this.state.muvisixproductkey,
															data.app_token,
															false,
															data.user_uuid,
															data.username,
															data.store_key
														)}
													</div>
												) : (
													<div></div>
												)}
											</li>
										</ul>
									))
								)}
							</div>
						</div>
					</div>
					<div class="customer_mob hidden-md">
						{this.state.customers.map((data, key) => (
							<div class="custmer_list_mob">
								<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
									<h4 class="list_title">{data.first_name}</h4>
								</Link>
								<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
									<div class="wrap">{data.domain}</div>
								</Link>
								{this.state.is_general_user != 1 ? (
									<div tabindex="0" class="onclick-menu pull-right">
										<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
										{this.getCustomersMenu(
											data.studio_id,
											data.first_name,
											data.user_id,
											data.email,
											data.encrypted_password,
											data.name
										)}
									</div>
								) : (
									<div></div>
								)}
							</div>
						))}
					</div>
				</div>
				{this.state.Loading ? (
					""
				) : (
					<span>
						{this.state.item_count > 0 ? (
							<div class="pagination-muvi">
								<Pagination
									itemClass={"pages"}
									itemClassFirst={"first_page"}
									itemClassPrev={"prev_page"}
									itemClassNext={"next_page"}
									itemClassLast={"last_page"}
									activePage={this.state.activePage}
									itemsCountPerPage={20}
									totalItemsCount={this.state.item_count}
									pageRangeDisplayed={5}
									onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
								/>
								<div style={{ color: "#333" }}>
									{this.state.muvisixproductkey == ""
										? this.state.offset +
										  1 +
										  " - " +
										  (this.state.offset + this.state.off_count) +
										  " of " +
										  this.state.item_count
										: this.muviSixpagination()}
								</div>
							</div>
						) : (
							<div className="text-center" style={{ color: "#333" }}>
								No Data Found
							</div>
						)}
					</span>
				)}
				{/* {this.loadMorecount()} */}
			</section>
		);
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				{/* <--modal start for cancelling account-!> */}
				<div class="modal fade" id="cancelAccount" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Cancel Account
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={this.state.studio_id.name}
									className="form-control"
									onChange={this.onChange}
									readOnly
								/>

								<input
									type="hidden"
									value={this.state.studio_id.id}
									name="studio_id"
									onChange={this.onChange}
								/>
								<input
									type="hidden"
									value={this.state.user_id.id}
									name="user_id"
									onChange={this.onChange}
								/>
								<br />
								<label>
									<b>Reason</b>
								</label>
								<textarea
									style={{ resize: "none" }}
									class="form-control"
									name="custom_notes"
									id="custom_notes"
									required
									onChange={this.onChange}
								></textarea>
								<span style={{ color: "red" }}>{this.state.message1}</span>
								<br />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-default"
									onClick={() => this.CancelAccount(this.state.studio_id.id, this.state.user_id.id)}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for cancelling account-!> */}

				{/* <--modal start for change Password-!> */}
				<div class="modal fade" id="changePassword" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Update Password
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>New Password</b>
								</label>
								<input
									type="text"
									name="new_password"
									id="new_password"
									className="form-control"
									onChange={this.onChange}
								/>
								<span style={{ color: "red" }}>{this.state.message}</span>
								<input type="hidden" value={this.state.studio_id.id} name="studio_id" />
								<input type="hidden" value={this.state.user_id.id} name="user_id" />
							</div>

							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-default"
									onClick={() => this.Savepassword(this.state.studio_id.id, this.state.user_id.id)}
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for change Password-!> */}
				<Header brecum_name="Customer" brecum_page="Demo" />
				<div className="right_col">{this.getDemoList()}</div>
			</div>
		);
	}
}
export default DemoList;



// WEBPACK FOOTER //
// ./src/components/customer/DemoStoreList.js